import styled from "styled-components";

export const ChildrenContainer = styled.div`
  display: flex;
`;

export const LoadingIconContainer = styled.div`
  margin-right: 0.5rem;
`;
